import { DateTime } from "luxon";

import { FormDescription } from "./FormDescription";
import { FormLabel } from "./FormLabel";

/** The browser's current local time, in the format a datetime-local input wants */
export function nowDateTimeLocal() {
  return DateTime.now().toFormat(`yyyy-MM-dd'T'HH:mm`);
}

interface DateTimeInputProps {
  label?: string;
  /** datetime-local format, e.g. 2026-08-24T14:30, or empty string */
  value: string;
  name?: string;
  onChange: (e: { value: string; name: string }) => void;
  className?: string;
  description?: string;
  max?: string;
  disabled?: boolean;
}

export function DateTimeInput({
  label,
  value,
  name,
  onChange,
  className,
  description,
  max,
  disabled,
}: DateTimeInputProps) {
  return (
    <div className={ className }>
      <FormLabel name={ name }>
        { label }
      </FormLabel>
      <div className={ `mt-2 rounded-md shadow-xs` }>
        <input
          type={ `datetime-local` }
          name={ name }
          id={ name }
          className={ `block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-paidniceGreen-600 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 sm:text-sm sm:leading-6` }
          value={ value }
          max={ max }
          disabled={ disabled }
          onChange={ e => onChange({ value: e.target.value, name }) }
        />
      </div>
      <FormDescription>
        { description }
      </FormDescription>
    </div>
  );
}
